const validate = (values) => {
  const errors = {};

  if (!values.password1) {
    errors.password1 = 'Password is required';
  }

  if (!values.password2) {
    errors.password2 = 'Password confirmation is required';
  }

  if (values.password1 !== values.password2) {
    errors.password2 = "Password doesn't match";
  }

  if (values.password1 && values.password1.length < 8) {
    errors.password1 = "Password must contain at least 8 characters";
  }

  if (values.password2 && values.password2.length < 8) {
    errors.password2 = "Password must contain at least 8 characters";
  }

  return errors;
};

export default validate;
